import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { preloadSpacesList } from '@confluence/space-utils/entry-points/preloadSpacesList';

import LeftPanelAdministrationHomeLeftPanelAdministrationQuery from '../LeftPanel/__generated__/LeftPanelAdministrationHomeLeftPanelAdministrationQuery.graphql';
import type {
	LeftPanelAdministrationHomeLeftPanelAdministrationQuery$data,
	LeftPanelAdministrationHomeLeftPanelAdministrationQuery$variables,
} from '../LeftPanel/__generated__/LeftPanelAdministrationHomeLeftPanelAdministrationQuery.graphql';

export const preloadHomeNavigation = ({
	isLoggedIn,
	isLicensed,
}: {
	isLoggedIn: boolean;
	isLicensed: boolean;
}) => {
	// Spaces list and Administration section shown in the left navigation
	return waitForAllReturnWhenError([
		preloadSpacesList({ isLicensed }),
		preloadLeftPanelAdministrationQuery({ isLoggedIn }),
	]);
};

const preloadLeftPanelAdministrationQuery = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
	const queryOptions = {
		query: LeftPanelAdministrationHomeLeftPanelAdministrationQuery,
		skip: !isLoggedIn,
	};
	return query<
		LeftPanelAdministrationHomeLeftPanelAdministrationQuery$data,
		LeftPanelAdministrationHomeLeftPanelAdministrationQuery$variables
	>(queryOptions);
};
